function playVideo() {
  var video = document.getElementById("video");

  if (video) {
    video.play().then((_) => {
      console.log("played!");
    });
  }
}

function onSuccess(url) {
  console.log(url);
  var video = document.createElement("VIDEO");
  if (!video.src) {
    video.id = "video";
    document.body.appendChild(video);
    video.src = url;
  }
}

function onProgress() {}

function onError() {}

// prefetch_file(
//   "https://raw.githubusercontent.com/FilePlayer/test/gh-pages/sw_360_lq.mp4",
//   onSuccess,
//   onProgress,
//   onError
// );

function prefetch_file(
  url,
  fetched_callback,
  progress_callback,
  error_callback
) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";

  xhr.addEventListener(
    "load",
    function () {
      if (xhr.status === 200) {
        var URL = window.URL || window.webkitURL;
        var blob_url = URL.createObjectURL(xhr.response);
        fetched_callback(blob_url);
      } else {
        error_callback();
      }
    },
    false
  );

  var prev_pc = 0;
  xhr.addEventListener("progress", function (event) {
    if (event.lengthComputable) {
      var pc = Math.round((event.loaded / event.total) * 100);
      if (pc != prev_pc) {
        prev_pc = pc;
        progress_callback(pc);
      }
    }
  });
  xhr.send();
}
export default prefetch_file;